/**
 * @Description 拓店-标准版本-机会点
 */

import { get, post } from '@/common/request/index';

const OPTIONS = { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true };



/**
 * @description 机会点管理-机会点列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/55509
 */
export function getChancePointList(params?:any) {
  return post('/standard/chancePoint/page', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点管理-机会点详情
 * @yapi https://yapi.lanhanba.com/project/623/interface/api/55530
 */
export function getChancePointDetail(params) {
  return post('/standard/chancePoint/detail', { ...params }, {
    isMock: false,
    mockId: 623,
    mockSuffix: '/api',
    needCancel: false,
    needHint: true,
  });
}

/**
 * 创建踩点任务
 * https://yapi.lanhanba.com/project/532/interface/api/55628
 */
export function footprintCreate(params: any) {
  return post('/standard/checkSpotProject/create', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    isZeus: false,
  });
}

/**
 * 机会点表单页
 * https://yapi.lanhanba.com/project/532/interface/api/55908
 */
export function getFormDetail(params:any) {
  return post(`/standard/chancePoint/formDetail`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    isZeus: false,
  });
}

/**
 * PC模版列表
 * https://yapi.lanhanba.com/project/532/interface/api/55831
 */

export function getTemplateLists() {
  return post('/standard/template/lists', {}, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}
/**
 * PC模版详情
 * https://yapi.lanhanba.com/project/546/interface/api/85161
 */
export function getTemplateDetail(params:any) {
  return post(`/standard/template/query`, params, {
    isMock: false,
    mockId: 546,
    mockSuffix: '/api',
    needHint: true,
  });
}
/**
 * PC机会点保存
 * https://yapi.lanhanba.com/project/532/interface/api/55796
 */
export function saveChancePoint(params:any) {
  return post(`/standard/chancePoint/save`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/** 拓店任务保存并提报点位评估 - https://yapi.lanhanba.com/project/532/interface/api/101028 */
export function submitTaskChancePoint(params: any) {
  return post('/standard/chancePoint/taskSubmit', params, OPTIONS);
}


/**
 * @description 机会点详情-模板导出
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/55852
 */
export function exportTemplateChancePoint(params) {
  return post('/standard/template/export', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点详情-机会点导入
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/55866
 */
export function importChancePoint(params) {
  return post('/standard/chancePoint/import', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点详情-机会点导入历史
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/55880
 */
export function importChancePointRecords(params) {
  return get('/standard/chancePoint/import/records', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点详情-机会点模板状态
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/55859
 */
export function importChancePointStatus(params) {
  return post('/standard/chancePoint/import/status', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * PC端机会点分页(动态配置列)
 * https://yapi.lanhanba.com/project/532/interface/api/59317
 */
export function getDynamicDetail(params) {
  const { isYiMing, ...requestParams } = params || {};
  delete requestParams.isDynamicHeaders;
  return post(isYiMing ? `/standard/chancePoint/dynamicEsPage` : `/standard/chancePoint/dynamicPage`, requestParams, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

/**
 * 商圈内的机会点列表
 * https://yapi.lanhanba.com/project/546/interface/api/89516
 */
export function getStandardChancePointPageByCluster(params) {
  return post(`/standard/chancePoint/page/byCluster`, params, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

/**
 * 关联机会点列表
 * https://yapi.lanhanba.com/project/532/interface/api/92835
 */
export function getchancePointAlias(params) {
  return post(`/standard/task/chancePointProcessInfo`, params, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

/**
 * PC端机会点分页(动态配置列)
 * https://yapi.lanhanba.com/project/532/interface/api/59317
 */
export function getDynamicDetailShare(params) {
  return post(`/standard/share/chancePoint/dynamicPage`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 机会点列表(益禾堂)
 * https://yapi.lanhanba.com/project/532/interface/api/82396
 */
export function getChancePointYhtPage(params) {
  return post(`/standard/chancePoint/yhtPage`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 删除机会点
 * https://yapi.lanhanba.com/project/532/interface/api/75319
 */
export function deleteChancepoint(params) {
  return post(`/standard/chancePoint/delete`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * PC端机会点机会点下拉框
 * https://yapi.lanhanba.com/project/532/interface/api/59583
 */
export function getChancepointSelection(params, config?: any) {
  return get(`/standard/chancePoint/selection`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    ...config,
  });
}

/**
 * 导出机会点
 * https://yapi.lanhanba.com/project/532/interface/api/63300
 */
export function chancepointExport(params) {
  return post(`/standard/chancePoint/export`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 机会点列表导出(益禾堂)
 * https://yapi.lanhanba.com/project/532/interface/api/82410
 */
export function chancepointExportYht(params) {
  return post(`/standard/chancePoint/yhtExport`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 根据机会点经纬度查询最近的规划商圈
 * https://yapi.lanhanba.com/project/532/interface/api/60479
 */
export function chancepointPlanCluster(params) {
  return post(`/standard/chancePoint/planCluster`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 根据机会点经纬度获取获取客群质量评分
 * https://yapi.lanhanba.com/project/532/interface/api/61375
 */
export function chancepointFlowScore(params) {
  return post(`/standard/chancePoint/flowScore`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}
/**
 * PC录入的集客点详情
 * https://yapi.lanhanba.com/project/546/interface/api/62271
 */
export function getSpotRelationDetail(params) {
  return get(`/plan/spot/relation/detail`, params, {
    isMock: false,
    mockId: 546,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * 根据机会点经纬度查询最近的选址地图商圈
 * https://yapi.lanhanba.com/project/532/interface/api/69544
 */
export function chancepointModelCluster(params) {
  return post(`/standard/chancePoint/modelCluster`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}


/**
 * 机会点报告首页
 * https://yapi.lanhanba.com/project/532/interface/api/70685
 */
export function chancepointReportHomeData(params) {
  return post(`/standard/chancePoint/report/home`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}


/**
 * 新机会点编辑-地图poi类型
 * https://yapi.lanhanba.com/project/532/interface/api/70685
 */
export function chancePointPoiTypes(params) {
  return post(`/standard/chancePoint/poi/types`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * 新机会点编辑-地图poi列表(地图用)
 * https://yapi.lanhanba.com/project/532/interface/api/70685
 */
export function chancePointPoiMapList(params) {
  return post(`/standard/chancePoint/poi/list`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * 新机会点编辑-poi列表(分页用)
 * https://yapi.lanhanba.com/project/532/interface/api/70685
 */
export function chancePointPoiPage(params) {
  return post(`/standard/chancePoint/poi/page`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * 机会点列表表头
 * https://yapi.lanhanba.com/project/532/interface/api/78434
 */
export function chancePointThead(params) {
  return get(`/standard/chancePoint/header`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * 机会点模版动态表头（一鸣）
 */
export function getChancePointDynamicHeaders(params?: any) {
  return get('/standard/chancePoint/dynamic/headers', params, {
    isMock: false,
    mockId: 644,
    mockSuffix: '/api',
    needHint: true,
  });
}


/**
 * @description PC新址评分保存
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/59415
 */
export function saveSpotScore(params?:any) {
  return post('/standard/chance/point/score/save', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description PC新址评分列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/79918
 */
export function spotScoreList(params?:any) {
  return post('/standard/chance/point/score/page', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点-点位测评-详情
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/79939
 */
export function chancePointEvaluation(params?:any) {
  return post('/standard/chancePoint/evaluation/detail', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * @description 获取预估销售额、预估销售额上限及外卖销售额
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/88380
 */
export function chancePointEstimatedSales(params?:any, config?: any) {
  return post('/standard/chancePoint/estimatedSales', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    ...config
  });
}

/**
 * @description 机会点-废弃列表分页查询
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/86603
 */
export function chancePointPageRecycle(params?:any) {
  return post('/standard/chancePoint/pageRecycle', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点详情(废弃库的机会点-详情)
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/86610
 */
export function chancePointRecycleDetail(params?:any) {
  return post('/standard/chancePoint/recycleDetail', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点-废弃操作
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/86589
 */
export function chancePointRecycle(params?:any) {
  return post('/standard/chancePoint/recycle', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点-恢复(撤销废弃)
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/86596
 */
export function chancePointRecovery(params?:any) {
  return post('/standard/chancePoint/recovery', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 客流点位详情列表
 * @yapi https://yapi.lanhanba.com/project/329/interface/api/88610
 */
export function getTaskAnalysisList(params?:any) {
  return post('/checkSpot/device/taskSpotAnalysisList', params, {
    isMock: false,
    mockId: 329,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description yht机会点关联踩点
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/97556
 */
export function postChancePointRelationCheckPoint(params?:any) {
  return post('/standard/chancePoint/relationCheckPoint', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 当前点位周边客流点位
 * @yapi https://yapi.lanhanba.com/project/329/interface/api/88608
 */
export function getTaskSpotSimplePage(params?:any) {
  return post('/checkSpot/device/taskSpotSimplePage', params);
}


/**
 * @description PC端创建分享链接（邀请好友填写）
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/92826
 */
export function postStandardShareFormCreate(params?:any) {
  // 接口开启压缩，参考 src/common/api/standardstore.ts 的 createChanceShareForm
  // 但实际默认好像就是开启的，所以这里暂不特殊处理
  return post('/standard/shareForm/create', params, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

/**
 * @description 保护记录分页列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99584
 */
export function postChancePointProtectionPage(params?:any) {
  return post('/standard/chancePoint/protection/page', params, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true, needCancel: false });
}

/**
 * @description 保护记录详情
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99586
 */
export function postChancePointProtectionDetail(params?:any) {
  return post('/standard/chancePoint/protection/detail', params, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

/**
 * @description 续期保护记录
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99588
 */
export function postChancePointProtectionExtend(params?:any) {
  return post('/standard/chancePoint/protection/extend', params, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

/**
 * @description 释放保护记录
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99590
 */
export function postChancePointProtectionRelease(params?:any) {
  return post('/standard/chancePoint/protection/release', params, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

/**
 * @description 机会点防撞店查询
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99602
 */
export function postChancePointCollisionCheck(params?:any) {
  return post('/standard/chancePoint/collisionCheck', params, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

/**
 * @description 机会点跟进记录分页列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99832
 */
export function postChancePointFollowRecordPage(params: any) {
  return post('/standard/chancePoint/followRecord/page', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * @description 新增机会点跟进记录
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99830
 */
export function postChancePointFollowRecordAdd(params: any) {
  return post('/standard/chancePoint/followRecord/add', params, OPTIONS);
}

/**
 * @description 查询一鸣决策报告-决策概览
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99858
 */
export function getYmDecisionReportOverview(params: any) {
  return post('/ym/decisionReport/overview', params, OPTIONS);
}

/**
 * @description 查询一鸣决策报告-审批入口
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99922
 */
export function getYmDecisionReportApprovalInfos(params: any) {
  return post('/ym/decisionReport/approvalInfos', params, OPTIONS);
}

/**
 * @description 查询一鸣决策报告-基本信息
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99860
 */
export function getYmDecisionReportBasicInfo(params: any) {
  return post('/ym/decisionReport/basicInfo', params, OPTIONS);
}

/**
 * @description 查询一鸣决策报告-核心指标卡
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99924
 */
export function getYmDecisionReportCoreIndicator(params: any) {
  return post('/ym/decisionReport/coreIndicator', params, OPTIONS);
}

/**
 * @description 查询一鸣决策报告-租金与承受力概览
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99936
 */
export function getYmDecisionReportRentAffordabilityOverview(params: any) {
  return post('/ym/decisionReport/rentAffordabilityOverview', params, OPTIONS);
}

/**
 * @description 查询一鸣决策报告-门店财务测算模型
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99862
 */
export function getYmDecisionReportFinancialCalculation(params: any) {
  return post('/ym/decisionReport/financialCalculation', params, OPTIONS);
}

/**
 * @description 查询一鸣决策报告-客群漏斗
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100506
 */
export function getYmDecisionReportCustomerFunnel(params: any) {
  return post('/ym/decisionReport/customerFunnel', params, OPTIONS);
}

/**
 * @description 商场慢闪决策报告-概览详情
 * @yapi https://yapi.lanhanba.com/project/668/interface/api/99990
 */
export function getMallDecisionReportDetail(params: any) {
  return post('/decision/mallReport/detail', params, OPTIONS);
}

/**
 * @description 商场慢闪决策报告-商务条件
 * @yapi https://yapi.lanhanba.com/project/668/interface/api/99992
 */
export function getMallDecisionReportBusinessInfo(params: any) {
  return post('/decision/mallReport/businessInfo', params, OPTIONS);
}

/**
 * @description 商场慢闪决策报告-客流情况
 * @yapi https://yapi.lanhanba.com/project/668/interface/api/99994
 */
export function getMallDecisionReportFlowInfo(params: any) {
  return post('/decision/mallReport/flowInfo', params, OPTIONS);
}

/**
 * @description 商场慢闪决策报告-商场情况
 * @yapi https://yapi.lanhanba.com/project/668/interface/api/99996
 */
export function getMallDecisionReportMallSituation(params: any) {
  return post('/decision/mallReport/mallSituation', params, OPTIONS);
}

/**
 * @description 商场慢闪决策报告-点位信息
 * @yapi https://yapi.lanhanba.com/project/668/interface/api/99998
 */
export function getMallDecisionReportPointInfo(params: any) {
  return post('/decision/mallReport/pointInfo', params, OPTIONS);
}

/**
 * @description 商场慢闪决策报告-智能决策
 * @yapi https://yapi.lanhanba.com/project/668/interface/api/100000
 */
export function getMallDecisionReportSmartDecision(params: any) {
  return post('/decision/mallReport/smartDecision', params, OPTIONS);
}

/**
 * @description 商场慢闪决策报告-多机会点对比列表
 * @yapi https://yapi.lanhanba.com/project/668/interface/api/101040
 */
export function getMallDecisionReportCompare(params: { pointIds: number[]; refresh?: boolean }) {
  return post('/decision/mallReport/compare', params, OPTIONS);
}
